/**
 * Remembers which method the user last authenticated with on THIS device, so the
 * login page can surface a "Last used" hint. Purely a local convenience (no PII,
 * no server) — survives sign-out on purpose, since that's exactly when the hint
 * is useful. Per-browser, like Google's/GitHub's account-chooser hints.
 */

export type AuthMethod = 'otp' | 'google' | 'microsoft';

const KEY = 'cs.lastAuth';

export function getLastAuthMethod(): AuthMethod | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'otp' || v === 'google' || v === 'microsoft' ? v : null;
  } catch {
    return null;
  }
}

export function setLastAuthMethod(method: AuthMethod): void {
  try {
    localStorage.setItem(KEY, method);
  } catch {
    // Ignore (private mode / storage disabled) — the hint is best-effort.
  }
}
